export default "__VITE_ASSET__DaeM_Tmi__"